import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

// Default fallback content (also used before API responds)
const DEFAULT = {
  hero: {
    eyebrow: "Services · Event's Multitechnique",
    lines: ["Du bâtiment", "à la scène,", "l'excellence technique."],
    subtitle: "Maintenance des bâtiments et production événementielle. Deux expertises, une seule équipe multitechnique à votre service.",
    image: "https://images.unsplash.com/photo-1478375846947-1abd989ab195?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxldmVudCUyMHNwYXJrbGVyfGVufDB8fHx8MTc4NTc4MjE4NXww&ixlib=rb-4.1.0&q=85",
  },
  maintenance: { label: "Maintenance des bâtiments", tag: "01 — Bâtiment", image: "", items: [] },
  evenementiel: { label: "Événementiel", tag: "02 — Production", image: "", items: [] },
  manifesto: [],
  gallery: [],
  contact: {
    phone: "07.58.60.76.42", phone_raw: "0758607642", whatsapp: "33758607642",
    email: "services.events@outlook.fr",
    instagram: "services_event", instagram_url: "https://www.instagram.com/services_event",
    facebook: "EVENT'S MULTITECHNIQUE", facebook_url: "https://www.facebook.com/profile.php?id=61592506626040",
  },
};

const Ctx = createContext({ content: DEFAULT, loaded: false, reload: () => {} });

export function ContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULT);
  const [loaded, setLoaded] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get("/content");
      setContent({ ...DEFAULT, ...data });
    } catch (_e) {
      setContent(DEFAULT);
    } finally {
      setLoaded(true);
    }
  };
  useEffect(() => { load(); }, []);

  return <Ctx.Provider value={{ content, loaded, reload: load }}>{children}</Ctx.Provider>;
}

export const useContent = () => useContext(Ctx).content;
export const useContentCtx = () => useContext(Ctx);
export { DEFAULT as DEFAULT_CONTENT };
